// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QX4sX","colBig":"styles_colBig__3B0xR","colSmall":"styles_colSmall__uep0y"};